import LegalHeader from "./LegalHeader";

export default LegalHeader;
